import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import LanguageSelectorModal from "./LanguageSelectorModal.vue";
import ExpandCollapse from "@/ui/shared/ExpandCollapse.vue";
import LanguageMenuItem from "@/ui/chrome/languageMenu/LanguageMenuItem.vue";
import LanguageSelector from "./LanguageSelector.vue";
import FooterLink from "./FooterLink.vue";
import FooterAddress from "./FooterAddress.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

const footer = computed<Vertica.LouisPoulsen.Application.Navigation.ViewModels.FooterViewModel>(() => store.getters["app/footer"]);
const selectedMode = computed<IMode>(() => store.getters["app/selectedMode"]);
const isCheckoutView = computed<boolean>(() => store.getters["app/isCheckoutView"]);
const selectedLanguage = computed<any>(() => store.getters["app/selectedLanguage"]);
const languages = computed<any[]>(() => store.getters["app/languages"]);

const isLanguageSelectorOpen = computed<boolean>(() => store.getters["navigation/isLanguageSelectorOpen"]);

const linkGroups = computed<Vertica.LouisPoulsen.Application.Navigation.ViewModels.FooterLinkGroup[]>(() => footer.value.linkGroups.filter(x => x.header && x.links.length));

function toggleShowLanguageSelect() {
    store.dispatch("navigation/toggleShowLanguageSelect");
}

function toggleNewsletterModal() {
    store.dispatch("navigation/toggleNewsletterModal");
}


return { __sfc: true,footer, selectedMode, isCheckoutView, selectedLanguage, languages, isLanguageSelectorOpen, linkGroups, toggleShowLanguageSelect, toggleNewsletterModal, LanguageSelectorModal, ExpandCollapse, LanguageMenuItem, LanguageSelector, FooterLink, FooterAddress }
}

})